<template>
	<button class="offer__cta" :class="[{ 'offer__cta--highlight': highlightCta }]">
		<svg
			v-if="isDvdOrBluRay"
			class="play-icon"
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 17 16"
			fill="none"
		>
			<path
				d="M1.16602 7.99984C1.16602 3.94932 4.44883 0.666504 8.49935 0.666504C12.5499 0.666504 15.8327 3.94932 15.8327 7.99984C15.8327 12.0504 12.5499 15.3332 8.49935 15.3332C4.44883 15.3332 1.16602 12.0504 1.16602 7.99984ZM5.74935 7.99984C5.74935 9.51807 6.98112 10.7498 8.49935 10.7498C10.0176 10.7498 11.2493 9.51807 11.2493 7.99984C11.2493 6.48161 10.0176 5.24984 8.49935 5.24984C6.98112 5.24984 5.74935 6.48161 5.74935 7.99984Z"
				fill="#D2D3D5"
			/>
		</svg>
		<FontAwesomeIcon v-else :icon="ctaIcon" size="lg" class="play-icon" />
		<span class="offer__cta__text">{{ ctaText }}</span>
	</button>
</template>

<script lang="ts" setup>
import { MonetizationType, PresentationType } from '@/@types/graphql-types';
import { computed } from 'vue';
import { BuyboxRegularOffer } from '@/features/buybox/types/types';
import { faPlay, faTicket } from '@fortawesome/free-solid-svg-icons';

const props = defineProps<{
	isBundle: boolean;
	offer: BuyboxRegularOffer;
}>();

const { t } = useI18n();

const highlightCta = computed(() => {
	return props.offer.monetizationType === MonetizationType.Flatrate && !props.isBundle;
});

const isDvdOrBluRay = computed(() =>
	[PresentationType.Dvd, PresentationType.Bluray, PresentationType.Bluray_4K].includes(props.offer?.presentationType)
);

const ctaText = computed(() => {
	if (isDvdOrBluRay.value) {
		return props.offer.monetizationType === MonetizationType.Rent ? t('WEBAPP_RENT_NOW') : t('WEBAPP_BUY_NOW');
	}
	return props.offer.monetizationType === MonetizationType.Cinema ? t('WEBAPP_BOOKNOW_CINEMA') : t('WEBAPP_WATCHNOW');
});

const ctaIcon = computed(() => {
	return props.offer.monetizationType === MonetizationType.Cinema ? faTicket : faPlay;
});
</script>

<style lang="scss" scoped>
.offer__cta {
	margin-inline-start: 8px;

	height: 40px;
	width: fit-content;
	min-width: 166px;
	padding: 8px 16px;
	border-radius: 8px;
	border: none;
	background: #303740;
	color: #c6c8cd;
	font-size: 16px;
	font-weight: 900;
	letter-spacing: 0.24px;
	cursor: pointer;

	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;

	display: flex;
	align-items: center;
	justify-content: center;

	.play-icon {
		margin-inline-end: 8px;
		flex: 0 0 auto;
		flex-shrink: 0;
		min-width: 20px;
		min-height: 20px;
		color: currentColor;
	}

	&:hover {
		background: #303740cb;
	}

	@media (max-width: 1100px) {
		min-width: 110px;
	}

	@media (max-width: 1050px) {
		min-width: 166px;
	}

	@media (max-width: 1024px) {
		min-width: 166px;
		width: fit-content;
		padding: 0 16px;
		margin-top: 26px;
		flex: 0 1 auto;
		margin-inline-start: 0;
	}

	&--highlight {
		background: #fbc500;
		color: #000;

		&:hover {
			background: #fbc500b1;
		}
	}

	&__text {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		line-height: 1;
	}
}
</style>
